<template>
  <div>
    <!-- 分词类 -->
    <div class="participle">
      <span>词性:</span>
      <!-- 按钮分类区域 -->
      <div class="btn">
        <button v-for="(item, index) in btn" :key="index" :class="top[index]">
          {{ item }}
        </button>
      </div>
    </div>
    <!-- 分词结果区域 -->
    <div
      class="endFenci"
      v-loading="loading"
      element-loading-background="rgba(16,164,178 ,0.2)"
    >
      <span v-for="(item, index) in allAll" :key="index" :class="item[1]">
        <!-- 去除数据里的空格 -->
        {{ item[0].replace(/\s*/g, "") }}
      </span>
    </div>
    <!-- 新词发现区域 -->
    <div class="xinci">
      <p>新词发现:</p>
      <span v-for="(item, index) in xinci" :key="index" :class="top[index]">{{
        item
      }}</span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      // 词性颜色表
      top: ["n", "v", "m", "y", "o", "a", "t", "x", "w", "z"],
      btn: [
        "名词",
        "动词",
        "数词",
        "语气词",
        "拟声词",
        "形容词",
        "时间词",
        "字符串",
        "标点符号",
        "状态词",
      ],
      // 分词数组
      allAll: [],
      // 新词
      xinci: [],
    };
  },
  components: {},
  computed: {},
  beforeMount() {},
  mounted() {},
  methods: {
    async Fenci(analyze) {
      this.loading = true;
      let data = { content: analyze };
      const { data: res } = await this.$http.post("/nlpir/ictclas", data);
      this.loading = false;
      this.allAll = res;
    },
    // 新词发现
    async Xinci(analyze) {
      let data = { content: analyze };
      const { data: res } = await this.$http.post("/nlpir/newWordFinder", data);
      let xinci = res;
      let new_xinci = xinci.map((obj) => {
        return obj.word;
      });
      this.xinci = new_xinci;
    },
  },
  watch: {},
};
</script>
<style lang= "less" scoped>
.endFenci {
  width: 99.5%;
  height: 279px;
  padding: 6px;
  overflow: auto;
  box-sizing: border-box;
}

.xinci {
  width: 100%;
  height: 40px;
  border: 1px solid #10a4b2;
  border-radius: 10px 10px 10px 10px;
  display: flex;
  align-items: center;

  p {
    color: #10a4b2;
    margin-left: 1.5%;
  }
}
.participle {
  width: 100%;
  height: 40px;
  border: 1px solid #10a4b2;
  border-top: none;
  border-radius: 10px 10px 10px 10px;
  display: flex;
  align-items: center;
  span {
    color: #10a4b2;
    margin-left: 1.5%;
  }
}

.n {
  background: #0336ff 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
.ns {
  background: #0336ff 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
.nt {
  background: #0336ff 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
.nz {
  background: #0336ff 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
.nl {
  background: #0336ff 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
.ng {
  background: #0336ff 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
.nrf {
  background: #0336ff 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
.nrj {
  background: #0336ff 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
.nr2 {
  background: #0336ff 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
.nr1 {
  background: #0336ff 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}

.v {
  background: #ef6e18 0% !important;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
.vn {
  background: #ef6e18 0% !important;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
.vl {
  background: #ef6e18 0% !important;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
}
.vd {
  background: #ef6e18 0% !important;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
.vn {
  background: #ef6e18 0% !important;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  text-align: center;
  line-height: 28px;
  width: 100px;
}
.vx {
  background: #ef6e18 0% !important;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
.vi {
  background: #ef6e18 0% !important;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  text-align: center;
  line-height: 28px;
  width: 100px;
}
.vg {
  background: #ef6e18 0% !important;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}

.m {
  background: #089109;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
.mq {
  background: #089109;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
.y {
  background: #bb2bac 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
.o {
  background: #00c6ff 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
.a {
  background: #6054ff;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
.ad {
  background: #6054ff;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
.an {
  background: #6054ff;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
.ag {
  background: #6054ff;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
.al {
  background: #6054ff;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}

.t {
  background: #a18cd1 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
.tg {
  background: #a18cd1 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
.x {
  background: #86080c 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}

.xe {
  background: #86080c 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
.xs {
  background: #86080c 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  text-align: center;
  line-height: 28px;
}
.xm {
  background: #86080c 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
.xu {
  background: #86080c 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}

.w {
  background: #ff9a9e 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}

// "wkz": "19",
.wkz {
  background: #ff9a9e 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
// "wky": "19",
.wky {
  background: #ff9a9e 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
// "wyz": "19",
.wyz {
  background: #ff9a9e 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
// "wyy": "19",
.wyy {
  background: #ff9a9e 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
// "wj": "19",
.wj {
  background: #ff9a9e 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
// "ww": "19",
.ww {
  background: #ff9a9e 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  text-align: center;
  line-height: 28px;
  width: 100px;
}
// "wt": "19",
.wt {
  background: #ff9a9e 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
// "wd": "19",
.wd {
  background: #ff9a9e 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  text-align: center;
  line-height: 28px;
  width: 100px;
}
// "wf": "19",
.wf {
  background: #ff9a9e 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
// "wn": "19",
.wn {
  background: #ff9a9e 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
// "wm": "19",
.wm {
  background: #ff9a9e 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
// "ws": "19",
.ws {
  background: #ff9a9e 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
// "wp": "19",
.wp {
  background: #ff9a9e 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
// "wb": "19",
.wb {
  background: #ff9a9e 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
// "wh": "19",
.wh {
  background: #ff9a9e 0%;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  text-align: center;
  line-height: 28px;
  width: 100px;
}

.z {
  background: #70fae3;
  border-radius: 3px;
  margin-left: 5px;
  color: #fff;
  border: 1px solid #10a4b2;
  height: 28px;
  width: 100px;
  text-align: center;
  line-height: 28px;
}
</style>
